"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var Services = _interopRequireWildcard(require("../../../services"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _sbUtils = require("@simplybenefits/sb-utils");
var _DivisionListItem = _interopRequireDefault(require("./components/DivisionListItem"));
var _Overview = _interopRequireDefault(require("./Overview"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Index = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Index, _PureComponent);
  function Index() {
    var _this;
    (0, _classCallCheck2["default"])(this, Index);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, Index, [].concat(args)), _this.state = {
      value: 0,
      divisionIDs: _sbUtils.helpers.sortObjByTitle(_this.props.divisions),
      selectedItem: 'overview',
      currentDivision: null,
      transactionsList: [],
      currentTransactionsComponents: [],
      loadIndex: 10,
      query: ''
    }, _this._selectDivision = function (selectedItem, divisionID) {
      var currentDivision = !divisionID ? null : _this.props.invoice.currentTransactions.divisions[divisionID];
      var divisionSummary = false;
      if (currentDivision) {
        // Find the summary for the division
        if (_this.props.invoice.summary.divisionSummaries) {
          divisionSummary = _this.props.invoice.summary.divisionSummaries.find(function (divSum) {
            return divSum.meta.divisionID === divisionID;
          });
        }

        // let's use the more complete totals from the current transactions division instead of the division summary as it's missing data we need
        divisionSummary.totals = currentDivision.totals;
      }
      _this.setState({
        selectedItem: selectedItem,
        divisionSummary: divisionSummary,
        currentDivision: currentDivision,
        selectedDivisionID: divisionID
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(Index, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.hideOverview) {
        // Get top division and show that as default instead of overview
        var topDivision = this.props.divisions[this.state.divisionIDs[0]];
        this._selectDivision(topDivision.title, topDivision.divisionID);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$invoice$m,
        _this2 = this,
        _this$state$currentDi;
      if (!this.props.invoice) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        alignItems: "center"
      }, this.props.isCurrent ? /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 4,
        sx: {
          paddingTop: "0px",
          paddingBottom: "0px",
          paddingLeft: "0px",
          paddingRight: "8px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        align: "center",
        mediumLarge: true,
        display: "inline"
      }, _i18n["default"].t(_tokens["default"].labels.invoices.currentAllocation))) : /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 4,
        sx: {
          padding: "8px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        align: "center",
        mediumLarge: true,
        display: "inline"
      }, dates.getLocalDisplay((_this$props$invoice$m = this.props.invoice.meta) === null || _this$props$invoice$m === void 0 ? void 0 : _this$props$invoice$m.dateAdded, 'MMMM YYYY', _i18n["default"].locale)))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 2,
        md: 3,
        sx: {
          paddingTop: "8px",
          paddingBottom: "8px",
          paddingLeft: "0px",
          paddingRight: "12px"
        }
      }, !this.props.hideOverview && /*#__PURE__*/_react["default"].createElement(_DivisionListItem["default"], {
        data: {
          title: _i18n["default"].t(_tokens["default"].labels.invoices.overview)
        },
        onSelect: function onSelect() {
          return _this2._selectDivision('overview');
        },
        selected: this.state.selectedItem === 'overview'
      }), _sbUtils.helpers.sortObjByTitle(this.props.divisions).map(function (divisionID, i) {
        var data = _this2.props.invoice.currentTransactions.divisions[divisionID];

        // if this division did not exist at time of the invoice generation then don't show the label
        if (!data) {
          return null;
        }
        var title = _this2.props.divisions[divisionID].title;
        var description = _this2.props.divisions[divisionID].description;
        return /*#__PURE__*/_react["default"].createElement(_DivisionListItem["default"], {
          id: i === 0 ? 'invoices-division' : "invoices-division-".concat(i),
          key: Services.concatTokens(divisionID, _this2.props.divisions[divisionID].title),
          data: {
            title: title,
            description: description
          },
          onSelect: function onSelect() {
            return _this2._selectDivision(title, divisionID);
          },
          selected: _this2.state.selectedItem === title
        });
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 10,
        md: 9,
        sx: {
          paddingTop: "8px",
          paddingBottom: "8px",
          paddingLeft: "4px",
          paddingRight: "0px"
        }
      }, !this.state.currentDivision && !this.props.hideOverview ? /*#__PURE__*/_react["default"].createElement(_Overview["default"], {
        invoice: this.props.invoice,
        overallSummary: this.props.invoice.summary.overallSummary,
        account: this.props.account,
        isCurrent: this.props.isCurrent,
        whitelabel: this.props.whitelabel,
        loading: this.props.loading,
        isDivisionSummary: false,
        accountClasses: this.props.accountClasses,
        divisions: this.props.divisions,
        hideOverview: this.props.hideOverview,
        isMasterSite: this.props.isMasterSite,
        downloadInvoice: this.props.downloadInvoice,
        users: Object.values(this.props.invoice.currentTransactions.users)
      }) : !((_this$state$currentDi = this.state.currentDivision) !== null && _this$state$currentDi !== void 0 && (_this$state$currentDi = _this$state$currentDi.records) !== null && _this$state$currentDi !== void 0 && _this$state$currentDi.length) ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          fontWeight: 600,
          textAlign: 'center',
          padding: 30,
          minWidth: '100%'
        }
      }, _i18n["default"].t(_tokens["default"].labels.invoices.noMembersUnderThisDivision)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, Boolean(this.state.divisionSummary) && /*#__PURE__*/_react["default"].createElement(_Overview["default"], {
        invoice: this.props.invoice,
        overallSummary: this.state.divisionSummary,
        account: this.props.account,
        isCurrent: this.props.isCurrent,
        divisionTitle: this.state.currentDivision.title,
        whitelabel: this.props.whitelabel,
        loading: this.props.loading,
        isDivisionSummary: true,
        selectedDivisionID: this.state.selectedDivisionID,
        accountClasses: this.props.accountClasses,
        divisions: this.props.divisions,
        hideOverview: this.props.hideOverview,
        isMasterSite: this.props.isMasterSite,
        triggerDivisionRepayment: function triggerDivisionRepayment() {
          return _this2.props.triggerDivisionRepayment(_this2.state.selectedDivisionID, _this2.props.invoice.invoiceNum);
        },
        downloadInvoice: this.props.downloadInvoice,
        users: Object.values(this.props.invoice.currentTransactions.users).filter(function (user) {
          return user.meta.divisionID === _this2.state.selectedDivisionID;
        })
      })))), /*#__PURE__*/_react["default"].createElement("span", {
        id: "invoices-overview"
      }));
    }
  }]);
  return Index;
}(_react.PureComponent);
Index.propTypes = {
  invoice: _propTypes["default"].object,
  divisions: _propTypes["default"].object
};
var _default = exports["default"] = Index;